export default "__VITE_ASSET__DiE8k7c1__"